import storage from './storage';

const DEFAULT_APP_ID = 'a2e5156e-07c5-486c-ba64-b1803d9e08ad';

export const setAppId = appId => storage.setItem('appId', appId);

export const getAppId = () => {
  const isRootPath = window.location.pathname === '/';
  if (isRootPath) {
    return DEFAULT_APP_ID;
  }

  return storage.getItem('appId') || DEFAULT_APP_ID;
};

export const removeAppId = () => storage.removeItem('appId');

export const setAppColors = colors =>
  storage.setItem('appColors', JSON.stringify(colors));

export const getAppColors = () => JSON.parse(storage.getItem('appColors'));

export const setAppName = name => storage.setItem('name', name);
export const getAppName = () => storage.getItem('name');

export const setAppDomain = domain => storage.setItem('domain', domain);
export const getAppDomain = () => storage.getItem('domain');

export const setApp = ({ id, colors, name, domain }) => {
  setAppId(id);
  setAppColors(colors);
  setAppName(name);
  setAppDomain(domain);
};

export const getApp = () => ({
  id: getAppId(),
  colors: getAppColors(),
  name: getAppName(),
  domain: getAppDomain(),
});

export const setFirst = value => storage.setItem('first', value);
export const getFirst = () => storage.getItem('first');
